module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Regular.8ce8e342.woff2";